import newUser from "./newUserSchema";

export const userSchemas = {
  newUser,
};
